import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as Sentry from "@sentry/browser";
import { BrowserRouter, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { CookiesProvider } from "react-cookie";
import "./vms/styles/notif.css";
import "./vms/styles/styles.css";
import NotificationContainer from "react-notifications/lib/NotificationContainer";
import VMS from "./vms/VMS";
import TagManager from "react-gtm-module";
import { gtmId, measurement_id } from "./config";

const tagManagerArgs = {
  gtmId: gtmId,
  dataLayer: {
    measurement_id,
  },
};
Sentry.init({ dsn: "https://01325f02ddb445e7951427081bfe0645@app.glitchtip.com/1730" });
TagManager.initialize(tagManagerArgs);
ReactDOM.render(
  <CookiesProvider>
    <Provider store={store}>
      <BrowserRouter>
        <NotificationContainer />
        <Route path="/">
          <App />
        </Route>
        <Route path="/vms">
          <VMS />
        </Route>
      </BrowserRouter>
    </Provider>
  </CookiesProvider>,
  document.getElementById("root")
);
// serviceWorker.unregister();
